import { useDataStore } from "src/modules/pe-basic-module/data/store"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import EventCard from "../components/EventCard"

interface IAficheProps {

}
const Afiche = (props: IAficheProps) :JSX.Element => { 
    const lands:ILand[] = useDataStore((state: any) => state.Land)
  

    return <div className="container-float mx-3">
        <div className="row ">
        {
            lands.map( event => <EventCard item={event} key={event.id} /> )
        }
        </div>
    </div>
} 

export default Afiche